const EQUIPMENT_LIST = [
    'Laser',
    'Kern',
    'Router',
    'Printer',
    '3-D Printer',
    '3DM Laser',
    'Engraver',
    'Paint',
    'Screen Printing',
    'Plotter/Other',
    'Tool Path',
    'Layout',
    'Paint Inspection',
    'Washer',
    'Final Assembly',
    'Other',
]

const EQUIPMENT_PROCESSES = {
    '3-D Printer': ['Text Only', 'Braille Only', 'Text and Braille', 'Flat Print', 'Other'],
    '3DM Laser': ['Initial Cut', '2nd Cut', 'Other'],
    'Laser': ['Cut Panels', 'Cut oversize panels for tie bond',
        '2nd cuts', 'Subsurface Mask For Window', 'Surface Mask For Window', 'Engrave',
        'Cut text', 'Cut Text On Sign Face', 'Cut Spacers', 'Inlay', 'Slider Parts and Pieces',
        'Layout and Cut', 'Cut Panel / Use Scraps', 'Subsurface Mask For Tie Bond', 'Other',
    ],
    'Kern': ['Cut Panels', 'Cut oversize panels for tie bond',
        '2nd cuts', 'Subsurface Mask For Window', 'Engrave',
        'Cut text', 'Cut Spacers', 'Inlay', 'Slider Parts and Pieces',
        'Layout', 'Cut', 'Cut Panel / Use Scraps', 'Other',
    ],
    'Router': ['Cut Panels', 'Cut oversize panels for tie bond',
        '2nd cuts', 'Mill/Notch/Cut', 'Bevel Cut',
        'Bull Nose', 'Eased Edges',
        'Layout', 'Cut', 'Cut Panel / Use Scraps', 'Cut Brackets / Angle Irons', 'Other',
    ],
    'Printer': ['Surface', 'Subsurface', 'Cardstock', 'Other'],
    'Engraver': ['Text and Braille', 'Braille Only', 'Other'],
    'Paint': ['Subsurface', 'Surface', 'Other'],
    'Screen Printing': ['Tipping', 'Other'],
    'Plotter/Other': ['Mask', 'Vinyl', 'Accent Bars', 'Other'],
}

module.exports = { EQUIPMENT_LIST, EQUIPMENT_PROCESSES }
